<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h3 class="mb-0">
            {{ isEdit ? 'تعديل فريق عمل' : 'إضافة فريق عمل' }}
          </h3>
          <b-card-text
            v-if="isEdit"
            class="mb-0 text-muted"
          >
            #{{ id }}
          </b-card-text>
        </div>
        <div>
          <b-button
            variant="outline-secondary"
            :to="{ name: 'team_works' }"
          >
            رجوع
          </b-button>
        </div>
      </div>
    </b-card>

    <b-card
      v-if="loadItem"
      class="text-center"
    >
      <b-spinner variant="primary" />
    </b-card>

    <b-card v-else>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <h5 class="mb-1">
              المسؤولين
            </h5>
          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="المهندس المسؤل">
              <v-select
                v-model="form.technical_responsible_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('technical_responsible_id')"
                class="text-danger"
              >{{ fieldError('technical_responsible_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="مسؤول الاتفاقية">
              <v-select
                v-model="form.office_agreement_responsible_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('office_agreement_responsible_id')"
                class="text-danger"
              >{{ fieldError('office_agreement_responsible_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="مسؤول المعاينة">
              <v-select
                v-model="form.office_inspection_responsible_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('office_inspection_responsible_id')"
                class="text-danger"
              >{{ fieldError('office_inspection_responsible_id') }}</small>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="مسؤول الرسم">
              <v-select
                v-model="form.office_drawing_responsible_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('office_drawing_responsible_id')"
                class="text-danger"
              >{{ fieldError('office_drawing_responsible_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="مسؤول QC">
              <v-select
                v-model="form.qc_responsible_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('qc_responsible_id')"
                class="text-danger"
              >{{ fieldError('qc_responsible_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="السائق">
              <v-select
                v-model="form.driver_id"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('driver_id')"
                class="text-danger"
              >{{ fieldError('driver_id') }}</small>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <h5 class="mb-1">
              فريق المعاينة (inspection_teams)
            </h5>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="فريق المعاينة">
              <v-select
                v-model="inspectionTeamsIds"
                :options="employeesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.full_name"
                dir="rtl"
                multiple
                :close-on-select="false"
                :clearable="true"
                @search="onEmployeeSearch"
                @option:selected="onEmployeeSelected"
              />
              <small
                v-if="fieldError('inspection_teams')"
                class="text-danger"
              >{{ fieldError('inspection_teams') }}</small>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <h5 class="mb-1">
              الموقع
            </h5>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group label="المحافظة">
              <v-select
                v-model="form.governorate_id"
                :options="governorates"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                @search="onGovernorateSearch"
              />
              <small
                v-if="fieldError('governorate_id')"
                class="text-danger"
              >{{ fieldError('governorate_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group label="الجهاز / الحي /المركز">
              <v-select
                v-model="form.center_id"
                :options="centers"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!form.governorate_id"
                @search="onCenterSearch"
              />
              <small
                v-if="fieldError('center_id')"
                class="text-danger"
              >{{ fieldError('center_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group label="الوحدة المحلية / الجهاز بالحي/ المدينة">
              <v-select
                v-model="form.city_id"
                :options="cities"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!form.center_id"
                @serach="onCitySearch"
              />
              <small
                v-if="fieldError('city_id')"
                class="text-danger"
              >{{ fieldError('city_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group label="القرية / التجمع">
              <v-select
                v-model="form.district_id"
                :options="districts"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!form.city_id"
                @search="onDistrictsSearch"
              />
              <small
                v-if="fieldError('district_id')"
                class="text-danger"
              >{{ fieldError('district_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group label="عزبة / نجع /منطقة">
              <v-select
                v-model="form.village_id"
                :options="villages"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!form.district_id"
                @search="onVillageSearch"
              />
              <small
                v-if="fieldError('village_id')"
                class="text-danger"
              >{{ fieldError('village_id') }}</small>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end">
          <b-button
            variant="primary"
            type="submit"
            :disabled="loadSave"
          >
            <b-spinner
              v-if="loadSave"
              small
              class="mr-50"
            />
            حفظ
          </b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BForm, BFormGroup, BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'TeamWorkForm',
  components: {
    BCard, BCardText, BRow, BCol, BForm, BFormGroup, BButton, BSpinner, vSelect,
  },
  computed: {
    ...mapGetters({
      item: 'teamWorks/item',
      loadItem: 'teamWorks/loadItem',
      loadSave: 'teamWorks/loadSave',
      employees: 'employees/employees',
      governorates: 'governorates/governorates',
      centers: 'centers/centers',
      cities: 'cities/cities',
      districts: 'districts/districts',
      villages: 'villages/districts',
    }),
    id() {
      return this.$route.params.id
    },
    isEdit() {
      return !!this.id
    },
    employeesOptions() {
      const apiEmployees = this.employees && this.employees.data ? this.employees.data : []
      const selected = this.Selected_employees || []
      const all = [...apiEmployees, ...selected]
      const unique = []
      const seen = new Set()
      for (const emp of all) {
        if (emp && emp.id && !seen.has(emp.id)) {
          seen.add(emp.id)
          unique.push(emp)
        }
      }
      return unique
    },
  },
  data() {
    return {
      Selected_employees: [],
      form: this.emptyForm(),
      inspectionTeamsIds: [],
      errors: {},
      touchedInspectionTeams: false,
      searchTimeout: null,
      initialSnapshot: null,
    }
  },
  watch: {
    'form.governorate_id': function (v) {
      this.form.center_id = null
      this.form.city_id = null
      this.form.district_id = null
      this.form.village_id = null
      console.log('v------------------5555555555', v)
      if (v) this.$store.dispatch('centers/list', { governorate_id: v })
    },
    'form.center_id': function (v) {
      this.form.city_id = null
      this.form.district_id = null
      this.form.village_id = null
      if (v) this.$store.dispatch('cities/list', { center_id: v })
    },
    'form.city_id': function (v) {
      this.form.district_id = null
      this.form.village_id = null
      if (v) this.$store.dispatch('districts/list', { city_id: v })
    },
    'form.district_id': function (v) {
      this.form.village_id = null
      if (v) this.$store.dispatch('villages/list', { district_id: v })
    },
    inspectionTeamsIds() {
      this.touchedInspectionTeams = true
    },
  },
  mounted() {
    this.$store.dispatch('employees/listEmployees', { query: {} })
    this.$store.dispatch('governorates/list', {})
    if (this.isEdit) this.load()
  },
  methods: {
    onEmployeeSelected(option) {
      if (!option) return
      if (Array.isArray(option)) {
        option.forEach(o => this.addEmployeeToSelected(o))
      } else {
        this.addEmployeeToSelected(option)
      }
    },
    addEmployeeToSelected(emp) {
      if (!emp || !emp.id) return
      const exists = this.Selected_employees.find(e => e.id === emp.id)
      if (!exists) {
        this.Selected_employees.push(emp)
      }
    },

    onGovernorateSearch(search, loading) {
      if (search) {
        const query = search ? { search } : {}
        this.$store.dispatch('governorates/list', query).then(res => {
        })
      }
    },
    onCenterSearch(search, loading) {
      if (search) {
        const query = search ? { search } : {}
        this.$store.dispatch('centers/list', query).then(res => {
        })
      }
    },
    onCitySearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('cities/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onDistrictsSearch(search) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('districts/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onVillageSearch(search) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('villages/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    emptyForm() {
      return {
        technical_responsible_id: null,
        office_agreement_responsible_id: null,
        office_inspection_responsible_id: null,
        office_drawing_responsible_id: null,
        qc_responsible_id: null,
        driver_id: null,
        governorate_id: null,
        center_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
      }
    },
    fieldError(key) {
      const v = this.errors && this.errors[key]
      return Array.isArray(v) ? v[0] : v || null
    },
    onEmployeeSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        const query = search ? { search } : {}
        this.$store.dispatch('employees/listEmployees', { query }).finally(() => {
          if (loading) loading(false)
        })
      }, 300)
    },
    async load() {
      await this.$store.dispatch('teamWorks/fetchItem', { id: this.id })
      const data = this.item || {}
      // Populate form IDs
      Object.keys(this.form).forEach(k => {
        this.form[k] = data[k] ?? null
      })
      // Cascade preload
      if (this.form.governorate_id) await this.$store.dispatch('centers/list', { query: { governorate_id: this.form.governorate_id } })
      if (this.form.center_id) await this.$store.dispatch('cities/list', { query: { center_id: this.form.center_id } })
      if (this.form.city_id) await this.$store.dispatch('districts/list', { query: { city_id: this.form.city_id } })
      if (this.form.district_id) await this.$store.dispatch('villages/list', { query: { district_id: this.form.district_id } })

      this.inspectionTeamsIds = Array.isArray(data.inspection_teams) ? data.inspection_teams.map(e => e.id) : []
      this.touchedInspectionTeams = false

      // Sync selected employees from details
      const employeeFields = [
        'technical_responsible',
        'office_agreement_responsible',
        'office_inspection_responsible',
        'office_drawing_responsible',
        'qc_responsible',
        'driver',
      ]
      employeeFields.forEach(field => {
        if (data[field]) this.addEmployeeToSelected(data[field])
      })
      if (Array.isArray(data.inspection_teams)) {
        data.inspection_teams.forEach(emp => this.addEmployeeToSelected(emp))
      }

      this.initialSnapshot = JSON.stringify({
        ...this.form,
        inspection_teams: [...this.inspectionTeamsIds],
      })
    },
    buildUpdatePayload() {
      const current = {
        ...this.form,
        inspection_teams: [...this.inspectionTeamsIds],
      }
      const initial = this.initialSnapshot ? JSON.parse(this.initialSnapshot) : null
      if (!initial) return current

      const changed = {}
      Object.keys(this.form).forEach(k => {
        if (current[k] !== initial[k]) changed[k] = current[k]
      })
      if (this.touchedInspectionTeams) {
        changed.inspection_teams = current.inspection_teams
      }
      return changed
    },
    onSubmit() {
      this.errors = {}
      const basePayload = {
        ...this.form,
        inspection_teams: [...this.inspectionTeamsIds],
      }

      const action = this.isEdit
        ? this.$store.dispatch('teamWorks/update', { id: this.id, data: this.buildUpdatePayload() })
        : this.$store.dispatch('teamWorks/store', { data: basePayload })

      action
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: { title: (res && res.message) || 'تم الحفظ', icon: 'CheckIcon', variant: 'success' },
          })
          this.$router.push({ name: 'team_works' })
        })
        .catch(err => {
          if (err && err.response && err.response.status === 422) {
            this.errors = (err.response.data && err.response.data.errors) || {}
            const msg = (err.response.data && err.response.data.message) || 'تحقق من الحقول المطلوبة'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'خطأ', icon: 'AlertTriangleIcon', variant: 'danger', text: msg,
              },
            })
            return
          }
          const msg = (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || 'حدث خطأ'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطأ', icon: 'AlertTriangleIcon', variant: 'danger', text: msg,
            },
          })
        })
    },
  },
}
</script>
